import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { Destination } from 'src/app/models/destination.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { DestinationService } from 'src/app/services/destination.service';

@Component({
  selector: 'app-destination-list',
  templateUrl: './destination-list.component.html',
  styleUrls: ['./destination-list.component.scss']
})
export class DestinationListComponent implements OnInit {
  // productsWithoutCost: InventoryProductWithoutCostResponse[] = [];
  // paginationProductsWithoutCost = new PaginationModel(0, 5, 0, 0, [], []);
  loading = false;
  destinations: any[] = [];
  showModalCreate = false;
  destinationName: string = null;
  destinationSelected: Destination = null;
  loadingCreate = false;
  buttonSave: ButtonLoading = new ButtonLoading("btn-success", false, "Crear", "fa-save");
  saving = 1;

  constructor(
    private destinationService: DestinationService,
    private toastService: ToastrService
  ) {

  }

  ngOnInit(): void {
  }

  setCurrentDestination(dest: Destination) {
      if(!dest) {
        this.destinationSelected = null;
        return;
      }
      this.destinationSelected = dest;
    }

  openModal() {
    this.showModalCreate = true;
    this.destinationName = null;
  }

  closeModal(event: any) {
    this.showModalCreate = false;
    this.destinationName = null;
  }

  addList() {
    if (!this.destinationName) {
      return
    }
    let data = { name: this.destinationName }
    this.loadingCreate = true;
    this.destinationService.createDestination(data).subscribe({
      next: (response: ResponseObject) => {
        this.toastService.success("Destino agregada.", "Exito");
        this.loadingCreate = false;
        this.saving += 1
        this.closeModal(true);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al agregar el destino.", "Error");
      }
    });

  }

}
